module.exports = __webpack_public_path__ + "331ac0609fccfe5c1ca02b3f72a0345b.png";